import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazySaveTheDateGuest = loadable(() => import(/* webpackChunkName: "content/saveTheDate/guest" */ './SaveTheDateGuest'), 'SaveTheDateGuest');
